/**
 * Запрашивает текущую позицию через браузерный Geolocation API.
 *
 * @returns позиция пользователя
 * @throws GeolocationPositionError или ошибка отсутствия поддержки API
 */
export const getMyPosition = (): Promise<GeolocationPosition> => {
  return new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      reject(new Error('Геолокация не поддерживается вашим браузером'))
      return
    }

    navigator.geolocation.getCurrentPosition(resolve, reject)
  })
}
